<div class="vision-statement">
  <div class="vision-statement--container">
    <div class="vision-statement--card">
      <div class="vision-statement--icon">
        <img src="/about-us/rocket.svg" alt="Rocket icon" class="vision-statement--icon-img" />
      </div>
      <h2 class="vision-statement--title">Vision Statement</h2>
      <p class="vision-statement--text">
        To ensure sustainable Agri management, conservation and utilisation of Agri resources unlocking value for a wide range of stakeholders through the creation of digital public infrastructure and digital public goods provisioning for interoperability, security and confidentiality.
      </p>
    </div>
  </div>
</div>
